<template>
  <div class="informationTextFull">
    <component :is="screenWidth < 375 ? 'Sm500Black' : 'Base500Black'">
      <slot />
    </component>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import Base500Black from '~/components/typography/Base500Black.vue'
import Sm500Black from '~/components/typography/Sm500Black.vue'

import resizeMixin from '~/mixins/resize'

export default defineComponent({
  components: {
    Base500Black,
    Sm500Black,
  },
  mixins: [resizeMixin],
})
</script>
